import styled from 'styled-components';
import { EventUpcoming } from '../Icons';
import { Today } from '@mui/icons-material';
import { Card } from '../Card';
import { VARIABLE_OPTION } from '../../constants';
import ContentContainer from '../containers/ContentContainer';
import { useModal } from '../../context/ModalContext';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import { setEditMode } from '../../redux/features/campaignOption/campaignOptionSlice';

const CampaignSelectorContainer = styled(ContentContainer)`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 0%;
  padding-bottom: 35px;
  font-size: 16px;
  background-color: transparent;
`;

const Cards = {
  0: {
    title: 'Edit entire campaign',
    supportingText: 'Place the same parameters across all months of activity',
    icon: <EventUpcoming />,
    value: VARIABLE_OPTION.EDIT_ENTIRE_CAMPAIGN
  },
  1: {
    title: 'Edit months individually',
    supportingText: 'Run separate parameters in each month',
    icon: <Today />,
    value: VARIABLE_OPTION.EDIT_MONTHS_INDIVIDUALLY
  }
};

const CampaignSelector = () => {
  const dispatch = useAppDispatch();
  const { closeModal, openModal } = useModal();
  const { editMode } = useAppSelector((state: RootState) => state.option);

  const handleOnChange = (option: VARIABLE_OPTION): void => {
    if (
      editMode !== undefined &&
      option === VARIABLE_OPTION.EDIT_ENTIRE_CAMPAIGN
    ) {
      openModal('ActionModal', {
        title: 'Warning',
        content:
          'When switching to "Edit entire campaign", all calculated loading values will be recalculated to the same loading values as the first available month. Click continue to switch.',
        cancelButtonText: 'Cancel',
        okButtonText: 'Continue',
        modalCallback: () => updateSelectedEditMode(option)
      });
    } else {
      updateSelectedEditMode(option);
    }
  };

  const updateSelectedEditMode = (option: VARIABLE_OPTION): void => {
    dispatch(setEditMode({ mode: option }));
    closeModal();
  };

  return (
    <CampaignSelectorContainer>
      {Object.values(Cards).map((card) => (
        <Card
          title={card.title}
          supportingText={card.supportingText}
          icon={card.icon}
          checked={editMode === card.value}
          onChange={() => handleOnChange(card.value)}
          value={card.value}
          key={card.value}
        />
      ))}
    </CampaignSelectorContainer>
  );
};

export default CampaignSelector;
